function arrayLengthsEqual(array) {
  var result = true;
  if (array.length > 0) {
    var benchMarkLength = array[0].length;
    for (var i = 1; i < array.length; i++) {
      if (array[i].length !== benchMarkLength) {
        result = false;
      }
    }
  }

  return result;
}

export function groupByIndex(array) {
  var result = [];
  var validArray = arrayLengthsEqual(array);

  if (validArray) {
    var subArrayLength = array[0].length;
    for (var i = 0; i < subArrayLength; i++) {
      var newSubArray = [];
      for (var j = 0; j < array.length; j++) {
        newSubArray.push(array[j][i]);
      }

      result.push(newSubArray);
    }
  }

  return result;
}

export function rotate(arr, turnsParam) {
  let turnsAdjusted = turnsParam;
  for (
    var l = arr.length,
      turns = (Math.abs(turnsAdjusted) >= l && (turnsAdjusted %= l), turns < 0 && (turns += l), turns),
      i,
      x;
    turns;
    turns = (Math.ceil(l / turns) - 1) * turns - l + (l = turns)
  )
    for (i = l; i > turns; x = arr[--i], arr[i] = arr[i - turns], arr[i - turns] = x);

  return arr;
}

export function joinArrays(array1, array2) {
  var length = Math.min(array1.length, array2.length);
  var result = [];
  for (var n = 0; n < length; n++) {
    result.push([array1[n], array2[n]]);
  }

  return result;
}

export function joinToleranceArrays(frequency, nominal, minimum, maximum) {
  var length = Math.min(frequency.length, nominal.length, minimum.length, maximum.length);
  var result = [];
  for (var n = 0; n < length; n++) {
    result.push([frequency[n], nominal[n], minimum[n], maximum[n]]);
  }

  return result;
}

export function getMinimumAndMaximumForOneStage(interestingCircuitValuesforOneStage) {
  var groupedByIndex = this.groupByIndex(interestingCircuitValuesforOneStage);
  var minForOneStage = [];
  var maxForOneStage = [];
  //loop through pts vs. frequency
  for (let j = 0; j < groupedByIndex.length; j++) {
    var minimum = Math.min.apply(Math, groupedByIndex[j]);
    var maximum = Math.max.apply(Math, groupedByIndex[j]);
    minForOneStage.push(minimum);
    maxForOneStage.push(maximum);
  }
  return { minForOneStage: minForOneStage, maxForOneStage: maxForOneStage };
}

export function getMinimumAndMaximumArray(interestingCircuitValuesArray, nominalValuesArray) {
  var minimumValues = [];
  var maximumValues = [];
  //loop through stages
  for (let i = 0; i < interestingCircuitValuesArray.length; i++) {
    if (nominalValuesArray) {
      interestingCircuitValuesArray[i].push(nominalValuesArray[i]);
    }

    // var groupedByIndex = this.groupByIndex(interestingCircuitValuesArray[i]);
    // var minForOneStage = [];
    // var maxForOneStage = [];
    // //loop through pts vs. frequency
    // for(let j = 0; j < groupedByIndex.length; j++) {
    //     var minimum = Math.min.apply(Math, groupedByIndex[j]);
    //     var maximum = Math.max.apply(Math, groupedByIndex[j]);
    //     minForOneStage.push(minimum);
    //     maxForOneStage.push(maximum);
    // }

    var result = this.getMinimumAndMaximumForOneStage(interestingCircuitValuesArray[i]);
    minimumValues.push(result.minForOneStage);
    maximumValues.push(result.maxForOneStage);
  }

  return { minimumValues, maximumValues };
}

export function addEnvelope(individualStageArray) {
  var groupedByIndex = this.groupByIndex(individualStageArray);
  var result = groupedByIndex.map((item) => {
    var sum = 0;
    for (var i = 0; i < item.length; i++) {
      sum += item[i];
    }

    return sum;
  });

  return result;
}
